import { Component, EventEmitter, Input, Output } from '@angular/core';
enum State {
	SelectionNotMade,
	SelectionMade
}

@Component({
	selector: 'activate-ccd-lsq-capable-selection-step',
	template: `
        <modal (close)="onModalClosed()"
               [escapeToClose]="false"
               [clickToClose]=false
               modalClasses="modal-wide">
            <header class="modal_header">
                <h2 class="text-center">
                    Remote Aircraft Status Capable
                </h2>
            </header>
            <div class="modal_body lsq-capable-selection-modal-body px-4 text-center modal_body-vertical-padding">
                <h2 class="text-center headline">
                    Is this {{deviceModelName}} capable of <strong>Remote Aircraft Status</strong> functionality?
                </h2>
                <p class="text-center">
                    Remote Aircraft Status allows a user to make a realtime request <br>
                    for aircraft status information from any location.
                </p>
                <p class="text-center bold-text">
                    This capability typically requires special wiring and configuration of the avionics.
                </p>
				<p class="text-center bold-text">
					Please confirm with your {{deviceModelName}} installation technician before proceeding.
				</p>
                <div>
                    <ul class="lsq-capable-selection-list">
                        <li (click)="makeLsqCapableSelection(true)"
                            [class.active]="isAircraftLsqCapable === true">
                            <label>
                                <input type="radio"
                                       name="isAircraftLsqCapable"
                                       [(ngModel)]="isAircraftLsqCapable"
                                       [value]="true">
								<i class="fa fa-check" aria-hidden="true"></i>
                                Yes, this {{deviceModelName}} is capable of Remote Aircraft Status
                            </label>
                        </li>
                        <li (click)="makeLsqCapableSelection(false)"
                            [class.active]="isAircraftLsqCapable === false">
                            <label>
                                <input type="radio"
                                       name="isAircraftLsqCapable"
                                       [(ngModel)]="isAircraftLsqCapable"
                                       [value]="false">
								<i class="fa fa-check" aria-hidden="true"></i>
                                No, this {{deviceModelName}} is not capable of Remote Aircraft Status
                            </label>
                        </li>
                    </ul>
                </div>
            </div>
            <footer class="modal_footer">
                <div>
                    <button [disabled]="currentState===State.SelectionNotMade"
                            (click)="onContinue()"
                            class="button button-primary py-1 px-5 modal_buttons">
                        CONTINUE
                    </button>
                </div>
            </footer>
        </modal>

	`,
})
export class ActivateCcdLsqCapableSelectionStepComponent {

	currentState: State = State.SelectionNotMade;
	isAircraftLsqCapable: boolean;
	@Input() deviceModelName: string;
	@Output() aircraftLsqCapableSelectionMade = new EventEmitter<boolean>();
	@Output() modalClosed = new EventEmitter();
	readonly State = State;

	onContinue() {
		this.aircraftLsqCapableSelectionMade.emit(this.isAircraftLsqCapable);
	}

	makeLsqCapableSelection(isAircraftLsqCapable: boolean) {
		this.isAircraftLsqCapable = isAircraftLsqCapable;
		this.currentState = this.isAircraftLsqCapable == null ? State.SelectionNotMade : State.SelectionMade;
	}

	onModalClosed() {
		this.modalClosed.emit();
	}
}
